import React, { createContext, useContext, useState, useEffect } from 'react';

const TempOrgContext = createContext();

export const useTempOrg = () => useContext(TempOrgContext);

export const TempOrgProvider = ({ children }) => {
    // Initialize state from localStorage
    const [tempOrg, setTempOrg] = useState(() => {
        const stored = localStorage.getItem('tempOrg');
        return stored ? JSON.parse(stored) : {};
    });

    // Keep localStorage in sync whenever tempOrg changes
    useEffect(() => {
        if (Object.keys(tempOrg).length === 0) {
            localStorage.removeItem('tempOrg');
        } else {
            localStorage.setItem('tempOrg', JSON.stringify(tempOrg));
        }
    }, [tempOrg]);

    // Listen to BroadcastChannel updates
    useEffect(() => {
        const channel = new BroadcastChannel('org_channel');
        channel.onmessage = (event) => {
            if (event.data.type === 'UPDATE_ORG') {
                setTempOrg(event.data.payload);
            } else if (event.data.type === 'REMOVE_ORG') {
                setTempOrg({});
            }
        };
        return () => channel.close();
    }, []);

    // Listen to storage events from other tabs
    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === 'tempOrg') {
                try {
                    setTempOrg(JSON.parse(event.newValue) || {});
                } catch {
                    setTempOrg({});
                }
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    return <TempOrgContext.Provider value={{ tempOrg, setTempOrg }}>{children}</TempOrgContext.Provider>;
};
